import React, { createContext, useContext, useEffect, useState } from 'react';
import { useFetchTimelineData } from '../data/fetchTimelineData';

export const FiltersContext = createContext(null);

export function useFilters() {
    return useContext(FiltersContext);
}

export function FiltersProvider({ children }) {
    const [filters, setFilters] = useState(null);
    const [request] = useFetchTimelineData();
    useEffect(() => {
        if (!request.isLoading && !request.isError) {
            setFilters(request.data.weekDays);
        }
    }, [request]);

    if (filters == null) {
        return null;
    }
    
    return (
        <FiltersContext.Provider value={filters}>
            {children}
        </FiltersContext.Provider>
    );
}
